import React from "react";

import "./alarming.scss";

const AlarmingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="uuid-2ac5bdc6-3547-4379-8098-6d669b2d01e2"
    data-name="uuid-54c6ee64-d56f-4160-ac14-ad9944f45bad"
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <rect
      id="uuid-97c74de0-f12a-4c2d-9fd0-d963d8765e3c"
      data-name="uuid-a29e00d9-d880-41ba-a51f-d842bd0c3694"
      className="alarmst3"
      width="24"
      height="24"
    />
    <circle
      id="uuid-8f531fb4-46cd-416d-9c2f-08672d8b6fa4"
      data-name="uuid-39a91b5b-2cc7-4491-8ebb-7ff6cc304046"
      className="alarmExclamation"
      cx="12"
      cy="12"
      r="12"
    />
    <path
      className="alarmBorder"
      d="m12,.5C5.718487.5.5,5.718487.5,12s5.218487,11.5,11.5,11.5,11.5-5.218487,11.5-11.5S18.281513.5,12,.5Zm1.256303,18.554623h-2.512605v-2.512605h2.512605s0,2.512605,0,2.512605Zm0-4.542017h-2.512605V5.428571h2.512605s0,9.084033,0,9.084035Z"
    />
    <path
      id="uuid-7e4e2ffd-630d-4e5b-ab44-ab9f2266e3f1"
      data-name="uuid-7a8df60d-872d-4eec-aa4f-31f470459d07"
      className="alarmExclamation"
      d="m12,2.2C6.6,2.2,2.2,6.6,2.2,12s4.4,9.799999,9.8,9.799999,9.799999-4.4,9.799999-9.8S17.4,2.2,12,2.2m0-2.2c6.6,0,12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12,5.4,0,12,0Z"
    />
  </svg>
);

export default AlarmingIcon;
